/* blocks */
import PageHero from '@/cmp/organism/PageHero/PageHero'
import CustomerLogo from '@/cmp/organism/CustomerLogo/CustomerLogo'
import Features from '@/cmp/organism/Feature/Features'
import Statistics from '@/cmp/organism/Statistics/Statistics'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'
import CaseStudyCarousel from '@/templates/CaseStudyCarousel/CaseStudyCarousel'
import ConversionFunnel from './components/ConversionFunnel'

/* utils */
import { UseCasePageAttributes } from '@/utils/queries/use_case'

interface Props {
  data: UseCasePageAttributes
  caseStudy: CaseStudy[]
}

function UseCase({ data, caseStudy }: Props): JSX.Element {
  return (
    <>
      <PageHero
        layout="center"
        primaryHeadline={data.hero.title}
        subText={data.hero.description}
        primaryCta={data.hero.primaryCta}
        secondaryCta={data.hero.secondaryCta}
        footNote={data.hero.footnote}
        image={data.hero.image?.data?.attributes}
      />

      {data.brands.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brands.title}
          brands={data.brands.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
        />
      ) : null}

      {data.conversionFunnel ? (
        <ConversionFunnel
          title={data.conversionFunnel.title ?? ''}
          description={data.conversionFunnel.description ?? ''}
          image={data.conversionFunnel.multimedia?.media?.data?.attributes}
        />
      ) : null}

      {data.featureListFixed.length > 0 ? (
        <Features
          mode="dark"
          list={data.featureListFixed.map(i => ({
            id: i.id,
            link: i.link,
            bgColor: i.color,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes,
            videoUrl: i.multimedia?.url ?? ''
          }))}
        />
      ) : null}

      {data.statisticsList.length > 0 ? (
        <Statistics
          title={data.statisticsTitle}
          statistics={data.statisticsList.map(i => ({
            stat: i.title ?? '',
            color: i.color,
            description: i.description ?? ''
          }))}
          mode="green"
        />
      ) : null}

      {caseStudy.length > 0 ? (
        <CaseStudyCarousel indicatorSize="sm" featured={caseStudy} />
      ) : null}

      {data.footerCta ? (
        <FooterCta
          headline={data.footerCta.title}
          mode="full_width"
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
        />
      ) : null}
    </>
  )
}

export default UseCase
